import type { TextShortcut } from "../../types.ts";
import { normalizeShortcutTrigger } from "../Shortcuts.helpers.ts";
import type { ShortcutFormState } from "./types.ts";

export function shortcutToForm(shortcut: TextShortcut): ShortcutFormState {
  return {
    id: String(shortcut.id),
    trigger: normalizeShortcutTrigger(shortcut.trigger),
    title: shortcut.title || "",
    scope: shortcut.scope === "global" ? "global" : "personal",
    body: shortcut.body || "",
  };
}

export function upsertShortcut(shortcuts: TextShortcut[], saved: TextShortcut): TextShortcut[] {
  const exists = shortcuts.some((item) => String(item.id) === String(saved.id));
  return exists
    ? shortcuts.map((item) => (String(item.id) === String(saved.id) ? saved : item))
    : [...shortcuts, saved];
}

export function sortShortcuts(shortcuts: TextShortcut[]): TextShortcut[] {
  return [...shortcuts].sort((a, b) => {
    if (a.scope !== b.scope) return a.scope === "personal" ? -1 : 1;
    return normalizeShortcutTrigger(a.trigger).localeCompare(normalizeShortcutTrigger(b.trigger));
  });
}

export function scopeLabel(scope: string): string {
  return scope === "global" ? "Todos" : "Meu";
}
